import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function ptoDetailsReducer(state = InitialState.ptoDetails, action) {
  
  switch (action.type) {
    case types.LOAD_PTO_DETAILS_SUCCESS:
      return {
        ...state,
        yearRolloverBalance: action.ptoDetails.yearRolloverBalance,
        monthDetails: action.ptoDetails.monthDetails,
        totals: action.ptoDetails.totals
      };
    default:
      return state;
  }
}